import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ThreadSharesLoadAction } from '../../domains/threadShares/actions.types';

import { ThreadShares } from './types';

const initialState: ThreadShares = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<ThreadShares, ThreadSharesLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.threadShares);
    case 'THREAD_SHARES.LOAD_PENDING':
      return moveToPending(state, [action.payload.threadId]);
    case 'THREAD_SHARES.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.threadId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
